<div class="page-header">
    <div class="row">
        <ol class="breadcrumb hide-on-mobile">
            @for (breadcrumb of breadcrumbs; track $index) {
                <li class="breadcrumb-item" [ngClass]="breadcrumb.active ? 'active' : null">
                    <a [attr.disabled]="breadcrumb.active" [routerLink]="breadcrumb?.url" [queryParams]="breadcrumb?.queryParams">{{ breadcrumb.title }}</a>
                </li>
            }
        </ol>
    </div>

    <div class="row">
        <div class="col-12 col-md-5">
            <h2>{{ title }} @if (sandBoxMode) { <mat-chip class="fs-6 badge bg-warning ml-2" matTooltip="Sandbox mode doesn't use credits, however usage of certain features is restricted.">Sandbox Mode</mat-chip> }</h2>
        </div>

        <div class="col-12 col-md-7 mobile-actions">
            @for (button of buttons; track $index) {
                @if (shouldDisplayButton(button)) {
                @switch (button.type) {
                    @case ('link') {
                        @switch (button.material) {
                            @default {
                                <a mat-button class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }

                            @case ('raised') {
                                <a mat-raised-button class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }

                            @case ('stroked') {
                                <a mat-stroked-button class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }

                            @case ('flat') {
                                <a mat-flat-button class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }

                            @case ('icon') {
                                <a mat-icon-button class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }

                            @case ('fab') {
                                <a mat-fab class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }

                            @case ('mini-fab') {
                                <a mat-mini-fab class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" [routerLink]="button.url">{{ button.title }}</a>
                            }
                        }
                    }
                    @case ('button') {
                        @switch (button.material) {
                            @default {
                                <button mat-button type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('raised') {
                                <button mat-raised-button type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('stroked') {
                                <button mat-stroked-button type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('flat') {
                                <button mat-flat-button type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('icon') {
                                <button mat-icon-button type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('fab') {
                                <button mat-fab type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('mini-fab') {
                                <button mat-mini-fab type="button" class="mobile-spacing float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color" (click)="callback(button)">{{ button.title }}</button>
                            }

                            @case ('siteStatus') {
                                <div class="hide-on-mobile">
                                    @if (siteStatuses) {
                                        <div class="site-status-btn float-end mx-1">
                                            <button mat-flat-button class="site-btn-left" [tourAnchor]="button.walkthroughAnchor" [color]="button.color">{{ button.title | titlecase }}</button>
                                            <button mat-flat-button [matMenuTriggerFor]="siteStatusMenu" class="site-btn-right" [color]="button.color"><mat-icon>expand_more</mat-icon></button>
                                            <mat-menu #siteStatusMenu="matMenu">
                                                @for (status of getSiteStatusByPhase(1); track $index) {
                                                    <button mat-menu-item [disabled]="checkIfDisabled(status.id)" (click)="callback(button, status)" matTooltipPosition="left" matTooltip="{{status.data?.isSyncable ? 'This status will be available to sync onto devices' : 'This status will be unable to sync onto devices' }}"><span><mat-icon>{{ status.data?.isSyncable ? 'sync' : '' }}</mat-icon>{{status.title | titlecase}}</span></button>
                                                }

                                                <hr />

                                                @for (status of getSiteStatusByPhase(2); track $index) {
                                                    <button mat-menu-item [disabled]="checkIfDisabled(status.id)" (click)="callback(button, status)" matTooltipPosition="left" matTooltip="{{status.data?.isSyncable ? 'This status will be available to sync onto devices' : 'This status will be unable to sync onto devices' }}"><span><mat-icon>{{ status.data?.isSyncable ? 'sync' : '' }}</mat-icon>{{status.title | titlecase}}</span></button>
                                                }

                                                <hr />

                                                @for (status of getSiteStatusByPhase(); track $index) {
                                                    <button mat-menu-item [disabled]="this.globalService?.site?.status?.id === status?.id" matTooltipPosition="left" matTooltip="{{status.data?.isSyncable ? 'This status will be available to sync onto devices' : 'This status will be unable to sync onto devices' }}"><span><mat-icon>{{ status.data?.isSyncable ? 'sync' : '' }}</mat-icon>{{status.title | titlecase}}</span></button>
                                                }
                                            </mat-menu>
                                        </div>
                                    } @else {
                                        <button mat-raised-button class="float-end mx-1" [tourAnchor]="button.walkthroughAnchor" [color]="button.color">{{ button.title | titlecase }}</button>
                                    }
                                </div>
                            }
                        }
                    }

                    @case ('info') {
                        @switch (button.material) {
                            @case ('displayDate') {
                                @if (button?.data?.survey_completed_at) { <p class="float-end m-2"><strong>{{ button.title | titlecase }}:</strong> {{button?.data?.survey_completed_at | date}}</p> }
                            }
                        }
                    }
                }
                }
            }
        </div>
    </div>
</div>

@if (authService.credits < 0) {
    <div class="row">
        <div class="col-12">
            <mat-card class="mx-2 mb-2" style="background-color: #f44336;">
                <mat-card-content>
                    <p style="margin: 0;"><mat-icon style="font-size: 20px; vertical-align: top;">warning</mat-icon> You have now entered a negative credit balance, please purchase credits to clear your negative balance.</p>
                    <button mat-raised-button class="float-end" style="margin-top: -30px;" (click)="purchaseCredits()">Buy Credits</button>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
}
